<template>
    <div>
        <div class="text-xs-left kath-sz-card">
            <h1 class="pb-5 sz-kath-title">{{Protocol['title']}}</h1>
            <div v-if="Protocol.hasOwnProperty('shortDescriptionString')"
                 class="short-description-string"
                 v-html="Protocol.shortDescriptionString"
            ></div>
            <div class="pb-3 subheading" v-html="Protocol['subtitle']"></div>
            <div class="pt-1"
                 v-if="Protocol.hasOwnProperty('resultPdfs')"
            >
                <div v-for="(resultPdf, key) in Protocol.resultPdfs"
                     :key="key"
                     @click.stop="openFile(resultPdf['link'])"
                     class="link"
                >
                    <h3 v-if="key === 0">
                        {{resultPdf['value']}}
                    </h3>
                    <div v-else>
                        {{resultPdf['value']}}
                    </div>

                </div>
            </div>
            <div class="pt-3"
                 v-if="Protocol.hasOwnProperty('shortResults')"
            >
                <h3> {{ProtocolTitles['shortResults']}}</h3>
                <div v-for="(sRes, key) in Protocol.shortResults" 
                :key="key"
                class="mt-2 sr-grid"
                >
                    <div> {{key + 1}}. </div><div v-html="sRes['value']"> </div>
                </div>

            </div>
            <div class="short-results-special-information"
                 v-if="Protocol.hasOwnProperty('shortResultsSpecialInformations')"
                 
            >
                <div v-for="specialInformation in Protocol.shortResultsSpecialInformations"
                 :key="specialInformation.title">
                    <div class="short-result-special-information-title font-weight-bold mt-3">
                        {{specialInformation.title}}
                    </div>
                    <div v-for="link in specialInformation.links"
                        :key="link.file"
                        @click="openFile(link.file)"
                        class="link"
                    >
                        {{link.name}}
                    </div>
                </div>
            </div>
            <div class="pt-3"
                 v-if="Protocol.hasOwnProperty('Traktanden')"
            >
                <h3 class="mb-2"> {{ProtocolTitles['traktanden']}}</h3>
                <div v-for="(trak, key) in Protocol.Traktanden" :key="key">
                    <div v-if="trak.hasOwnProperty('unterTraktanden')" class="mb-3">
                        <div class="mb-2">
                            {{trak['value']}}
                        </div>
                        <div v-for="ut in trak.unterTraktanden" :key="ut"
                             class="ml-3 ma-1"
                        >
                            <div>
                                {{ut.prefix}}. {{ut.value}}
                            </div>
                            <div v-if="ut.hasOwnProperty('unterUnterTraktanden')"
                                 
                            >
                                <div v-for="uut in ut.unterUnterTraktanden"
                                 :key="uut"
                                 class="ml-3">
                                    {{uut.prefix}} {{uut.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        {{key + 1}}. {{ trak['value']}}
                    </div>
                </div>
            </div>
            <div class="pt-3"
                 v-if="Protocol.hasOwnProperty('Unterlagen')"
            >
                <h3 class="pb-2"> {{ProtocolTitles['unterlagen']}}</h3>
                <div v-for="(file, key) in Protocol.Unterlagen"
                     :key="key" @click.stop="openFile(file['link'])"
                     class="link"
                >
                    - {{file['value']}}
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: "protocol-detailed",
        props: ['id'],
        methods: {
            openFile(filename){
                window.open( filename, '_blank');
            },
        },
        computed: {
            Protocol () {
                return this.$store.getters.sessionProtokoll(this.id);
            },
            ProtocolTitles () {
                return this.$store.getters.ProtocolTitles;
            },
        },
        beforeCreate() {
            this.$store.dispatch('setViewSizeToSmall')
            //scroll on top before enter
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }
</script>

<style scoped>

</style>